// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settings-btn {\n  height: auto;\n  margin-left: 5px;\n  --box-shadow: none ;\n}\n\n.item-text {\n  opacity: 0.75;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
